module.exports = __webpack_public_path__ + "static/media/21.2a9da6fb.svg";